import React, { Component, Fragment, useState, useEffect } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

const SubNavigation = (props) => {
    
    const decodeHtml = (htmlString) => {
        var txt = document.createElement('textarea');
        txt.innerHTML = htmlString;
        return txt.value;
    }
    
        const links = JSON.parse(decodeHtml(props.links));
        const FilterList = React.createRef();
        const ListContainer = React.createRef();
        const SCROLL_AMOUNT = 200;
        
        let _timeout = null;        
        const [showArrowRight, setshowArrowRight] = useState(false);
        const [showArrowLeft, setshowArrowLeft] = useState(false);

useEffect(() => {
    const selectedItem = document.querySelector(".sub-navigation__list-item--active");
    const allListElements = document.querySelectorAll(".sub-navigation__list-item");
    const containerWidth = ListContainer.current.clientWidth;
    const list = FilterList.current;

    if (selectedItem != null) {
        const paddingLeft = window.getComputedStyle(allListElements[0], null).getPropertyValue('padding-left');
        const selectedItemPosition = selectedItem.offsetLeft - parseInt(paddingLeft, 10) - 16;
        moveList(selectedItemPosition);
    }

    if (containerWidth < list.scrollWidth && allListElements.length > 1) {
        setshowArrowRight(true);        
    }
    smoothscroll.polyfill(); //For smooth scroll in Safari
}, []);


    const moveList = (scrollAmnt) => {
        const list = FilterList.current;
        const scroll = (left, callback) => list.scroll({ left, top: 0, behavior: "smooth" })

        scroll(scrollAmnt);
    }

    const toggleArrows = () => {
        const list = FilterList.current;

        setTimeout(() => {
            if ((list.scrollLeft <= 0)) {
                setshowArrowLeft(false);                
            }
            else {
                setshowArrowLeft(true);                
            }

            if ((list.scrollLeft + list.offsetWidth >= list.scrollWidth - SCROLL_AMOUNT / 4)) {
                showArrowRight(false);                
            }

            else {
                showArrowRight(true);                
            }
        }, 750)

    }

    const handleArrowClick = (dir) => {
        const list = FilterList.current;
        const scrollLeft = list.scrollLeft;
        const scrollAmnt = scrollLeft + (dir * SCROLL_AMOUNT)
        moveList(scrollAmnt)
    }

    const handleScroll = () => {
        if (_timeout) { //if there is already a timeout in process cancel it
            clearTimeout(_timeout);
        }
        _timeout = setTimeout(() => {
            _timeout = null;
            toggleArrows();
        }, 150);
    }
    
        return (
            <Fragment>
                {links &&
                    <div className="sub-navigation row">
                        <button
                            className={`sub-navigation__arrow sub-navigation__arrow--left ${showArrowLeft ? "sub-navigation__arrow--active" : ""}`}
                            onClick={(e) => handleArrowClick(-1)}>
                            <svg className="sub-navigation__icon">
                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use>
                            </svg>
                        </button>
                        <div className="sub-navigation__list-container" ref={ListContainer}>
                            <ul className="sub-navigation__list" ref={FilterList} onScroll={() => handleScroll()}>
                                {links && links.map((item, index) => {
                                    return (
                                        <li key={index} className={`sub-navigation__list-item ${item.isSelected ? "sub-navigation__list-item--active" : ""}`}>
                                            <a href={item.url} className={`sub-navigation__link ${item.isSelected ? "sub-navigation__link--active" : ""}`}> {item.name}</a></li>)
                                })}
                            </ul>
                            <div className="sub-navigation__fade--left  sub-navigation__fade"></div>
                            <div className="sub-navigation__fade--right sub-navigation__fade" ></div>
                        </div>
                        <button
                            className={`sub-navigation__arrow ${showArrowRight ? "sub-navigation__arrow--active" : ""}`}
                            onClick={(e) => handleArrowClick(1)}>
                            <svg className="sub-navigation__icon"><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>
                        </button>
                    </div>
                }
            </Fragment>
        );    
}

export default SubNavigation;